export default function downloadPdf(linkPDF, name) {
	this.$axios(linkPDF, { responseType: 'blob' })
		.then((response) => {
			const blob = new Blob([response.data], { type: 'application/pdf' });
			const link = document.createElement('a');
			link.href = URL.createObjectURL(blob);
			link.download = name;
			link.click();
			URL.revokeObjectURL(link.href);
		})
		.catch((error) => {
			console.error('Ошибка скачивания файла: ', error);
		});
}
